<div class="row border py-3 rounded m-0">
  <div class="col-md-auto">
    <strong>MRN</strong>
    <div class="phi">{{ task.patient.mrn }}</div>
    @if (displayUserPresence) {
      <app-user-presence category="clientPrescriberTask" [targetId]="task.id" />
    }
  </div>
  <div class="col-md-auto">
    <strong>Patient Name</strong>
    <div class="phi">{{ task.patient.fullName }}</div>
    <app-patient-alternate-names [patient]="task.patient" />
  </div>
  <div class="col-md-auto">
    <strong>DOB</strong>
    <div class="phi">{{ task.patient.dob | date: 'MM/dd/yyyy' }}</div>
  </div>
  <div class="col-md-auto">
    <strong>Task Type</strong>
    <div>{{ task.humanizedType }}</div>
  </div>
  <div class="col-md-auto">
    <strong>Status</strong>
    <div>{{ task.humanizedStatus }}</div>
  </div>
  <div class="col-md-auto">
    <strong># of Linked Claims</strong>
    <div>{{ task.captureCount }}</div>
  </div>
  <div class="col-md-auto">
    <strong>Value</strong>
    <div><app-task-estimated-value [rank]="task.estimatedValueRank" [value]="task.estimatedValue" /></div>
  </div>
  @if (task.processedBy) {
    <div class="col-md-auto">
      <strong>Submitted By</strong>
      <div>{{ task.processedBy ? task.processedBy.username : null | blankValueDash }}</div>
    </div>
  }
  @if (task.processedBy) {
    <div class="col-md-auto">
      <strong>Submitted At</strong>
      <div>{{ task.processedAt | date: 'MM/dd/yyyy' }}</div>
    </div>
  }
</div>
